import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Menu } from 'semantic-ui-react';
import UserPlaylist from '../../App/UserPlaylistQuery';
import { MobileModal } from '../../Modules';
import { RootConsumer } from '../../RootComponent';
import MyPlaylists from './MyPlaylists';
import DiscoverPlaylists from './DiscoverPlaylists';

export default class AddRecommendations extends React.Component {
  static propTypes = {
    activePlaylist: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    relay: PropTypes.object.isRequired,
    parentID: PropTypes.string.isRequired,
    playlistRecommendations: PropTypes.array.isRequired,
    togglePlaylist: PropTypes.func.isRequired,
    viewer: PropTypes.object,
    viewPlaylist: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.getMyPlaylists().length > 0 ? 'my' : 'discover'
    };
    this.getActivePlaylist = this.getActivePlaylist.bind(this);
    this.getAllPlaylists = this.getAllPlaylists.bind(this);
    this.getMyPlaylists = this.getMyPlaylists.bind(this);
    this.getPublicPlaylists = this.getPublicPlaylists.bind(this);
    this.isSelected = this.isSelected.bind(this);
  }

  getActivePlaylist() {
    const filtered = this.getAllPlaylists().filter(
      p => p.node.id === this.props.activePlaylist
    );
    return filtered[0].node;
  }

  getAllPlaylists() {
    return this.props.viewer.public_playlists.edges.concat(
      this.props.viewer.playlists.edges
    );
  }

  getMyPlaylists() {
    return this.props.viewer.playlists.edges.filter(
      p =>
        !this.getPublicPlaylists()
          .map(publicPlaylist => publicPlaylist.node.id)
          .includes(p.node.id)
    );
  }

  getPublicPlaylists() {
    return this.props.viewer.public_playlists.edges;
  }

  isSelected(playlistId) {
    return this.props.playlistRecommendations
      .map(({ node: r }) => r.id)
      .includes(playlistId);
  }

  render() {
    const {
      activePlaylist,
      onClose,
      parentID,
      relay,
      togglePlaylist,
      viewPlaylist,
      viewer
    } = this.props;

    const { activeTab } = this.state;

    const Tabs = (
      <RootConsumer>
        {({ isMobile }) =>
          <Menu
            secondary
            pointing
            style={{ marginTop: isMobile ? '48px' : 'auto' }}
          >
            <Menu.Item
              name='Discover'
              onClick={() => this.setState({ activeTab: 'discover' })}
              active={activeTab === 'discover'}
            />
            <Menu.Item
              name='My Playlists'
              onClick={() => this.setState({ activeTab: 'my' })}
              active={activeTab === 'my'}
            />
          </Menu>}
      </RootConsumer>
    );

    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div
            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            {isMobile &&
              <MobileModal.Header>
                <div className='menu'>
                  <a
                    className='item'
                    onClick={
                      activePlaylist ? () => viewPlaylist(null, null) : onClose
                    }
                  >
                    <Icon name='chevron left' />
                  </a>
                </div>
              </MobileModal.Header>}
            {!activePlaylist &&
              <React.Fragment>
                <div style={{ padding: isMobile ? '1em' : '2em' }}>{Tabs}</div>
                {activeTab === 'my' &&
                  <MyPlaylists
                    playlists={this.getMyPlaylists()}
                    togglePlaylist={togglePlaylist}
                    isSelected={this.isSelected}
                    onClose={onClose}
                    relay={relay}
                    viewer={viewer}
                    parentID={parentID}
                  />}
                {activeTab === 'discover' &&
                  <DiscoverPlaylists
                    playlists={this.getPublicPlaylists()}
                    togglePlaylist={togglePlaylist}
                    isSelected={this.isSelected}
                    onClose={onClose}
                  />}
              </React.Fragment>}
            {activePlaylist &&
              <div>
                {!isMobile &&
                  <p>
                    <a onClick={() => viewPlaylist(null, null)}>
                      &lt; Back to Playlists
                    </a>
                  </p>}
                <UserPlaylist
                  playlistId={this.getActivePlaylist().id}
                  relay={relay}
                  parentID={parentID}
                  goBack={() => viewPlaylist(null, null)}
                />
              </div>}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/AddRecommendations.js